import { type MCPServerInfo } from '../../types';

const GithubStdioServer: MCPServerInfo = {
  serverId: 'GITHUB_STDIO',
  name: 'GitHub (local)',
  slug: 'github-stdio',
  description:
    'GitHub MCP Server running locally. Interact with repositories, issues, pull requests, and more.',
  authenticationType: 'NONE',
  source: {
    sourceType: 'LOCAL_PACKAGE',
    transport: 'STDIO',
    commandFunction: `(config) => ({
      command: 'npx',
      args: ['-y', 'github-local-mcp'],
      env: {}
    })`
  },
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  },
  deprecated: true
};

export default GithubStdioServer;
